import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios'; // We will use axios for making API requests
import { API_URL } from '../../constants/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const { forgotRoute } = useParams();
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Simple validation for demo purposes
    if (!email) {
      setError('Email is required.');
      return;
    }

    try {
      // API call to login
      const response = await axios.post(
        `${API_URL}/api/users/forgot-password/${forgotRoute}`,
        {
          email,
        }
      );

      if (response.data.success === 1) {
        setSuccess(response.data.message);
        setError(null);
      } else {
        setError(response.data.message);
        setSuccess(null);
      }
      // Redirect to the dashboard
      // navigate('/reset-password');
    } catch (error) {
      // Handle error (e.g., invalid credentials)
      setError('Invalid email');
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-100">
      <div className="col-md-4 p-4 border rounded shadow-lg bg-light">
        <h2 className="text-center mb-4">Forgot Password</h2>

        {error && <div className="alert alert-danger">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              Email
            </label>
            <input
              type="email"
              className="form-control"
              id="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <button type="submit" className="btn btn-primary">
              Request Reset Password
            </button>
            <a href="/login" className="text-decoration-none">
              Login
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
